export const addCurrentFullProfile = (current) => {
    return (dispatch, getState) => {
        dispatch({ type: 'ADD_CURRENT_FULL_PROFILE', full_profile: current });
    }
};
